/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-up': {
    width: 19,
    height: 32,
    viewBox: '0 0 19 32',
    data: '<path pid="0" d="M1 9.596l8.182-8.182 8.182 8.182m-8.182-8.09v29.173" _stroke="#C09C5E" stroke-width="2" stroke-linecap="round"/>'
  }
})
